// ============================================================================
// הגדרות המערכת של המשתמש המחובר (settings/get_settings_details)
// ============================================================================
// נטען פעם אחת ונשמר לכל הרכיבים שצריכים אותו (תפריט הצד, דף הבית).
// אם הטוקן משתנה (למשל אדמין שעבר למערכת של לקוח) - נטען מחדש.
// ============================================================================
import ApiServices from '@/services/api.service';

let cached = null;
let cachedToken = null;

export function getSystemSettings() {
  const token = localStorage.getItem('token');
  if (!token) return Promise.resolve(null);
  if (cached && cachedToken === token) return cached;
  cachedToken = token;
  cached = fetch(`${process.env.VUE_APP_BASE_URL}/settings/get_settings_details`, ApiServices.requestOptions('GET', '', token))
    .then((res) => (res.status === 200 ? res.json() : null))
    .catch(() => null);
  return cached;
}

// שלוחת הסקרים כלולה במערכת (exten_permissions.surveys - לפי האדמין או הסוכן)
export async function isSurveysAllowed() {
  const d = await getSystemSettings();
  return !!(d && d.exten_permissions && d.exten_permissions.surveys);
}